import React from 'react';
import css from './GrabHostYourCarLandingPage.css';
import classNames from 'classnames';
import Slider from 'react-slick';
import imageSource from '../../util/imageSource';

const WhyHostWithDrivelah = ({ isMobileLayout, handleSignupRedirect }) => {
  const gridContent = [
    {
      contentImage: imageSource.grabBanner.image1,
      contentTitle: 'Passive Income',
      contentDescription:
        'Dont let your car sit idle, maximise your earnings by renting it out on your off days/hours',
      contentAlt: 'Budget car rental services in Singapore | Drive lah',
    },
    {
      contentImage: imageSource.grabBanner.image2,
      contentTitle: 'Flexible Hosting',
      contentDescription:
        "With thousands of relief drivers on our platform, you decide when to rent out your car. Hourly, daily, weekly. It's your choice.",
      contentAlt: 'Long term car rental Singapore for your next family trip | Drive lah',
    },
    {
      contentImage: imageSource.grabBanner.image3,
      contentTitle: 'Keyless handovers ',
      contentDescription:
        'Stay safe and away from contact by allowing your relief driver to unlock your car securely through the Drive lah',
      contentAlt: 'Rent a car for a day with Drive lah',
    },
  ];
  const sliderConfig = {
    // className: css.slider,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 4,
    initialSlide: 0,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          initialSlide: 0,
          infinite: false,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          dots: true,
          arrows: false,
        },
      },
    ],
  };
  return (
    <div className={css.whyHostWithUs}>
      <div className={css.container}>
        <div className={classNames(css.row, css.secTitle)}>
          <div className={css.column12}>
            <h3>Why rent out with Drive lah?</h3>
          </div>
        </div>
        <div className={classNames(css.row, css.contentGrid)}>
          {isMobileLayout ? (
            <div className={css.sliderWrapper}>
              <Slider {...sliderConfig}>
                {gridContent &&
                  gridContent.length > 0 &&
                  gridContent.map((content, i) => {
                    return (
                      <div className={css.column4}>
                        <div className={css.contentBlock}>
                          <div className={css.contentBlockThumb}>
                            <img src={content.contentImage} alt={content.contentAlt} />
                          </div>
                          <div className={css.contentBlockContent}>
                            <h4>{content.contentTitle}</h4>
                            <p>{content.contentDescription}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </Slider>
            </div>
          ) : (
            gridContent &&
            gridContent.length > 0 &&
            gridContent.map((content, i) => {
              return (
                <div className={css.column4}>
                  <div className={css.contentBlock}>
                    <div className={css.contentBlockThumb}>
                      <img src={content.contentImage} alt={content.contentAlt} />
                    </div>
                    <div className={css.contentBlockContent}>
                      <h4>{content.contentTitle}</h4>
                      <p>{content.contentDescription}</p>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div className={classNames(css.row, css.btnRow)}>
          <div className={css.column12}>
            <button onClick={e => handleSignupRedirect(e)} className={css.bannerButton}>
              List your car now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyHostWithDrivelah;
